namespace TabAurous.Master {
    export interface EmployeeDetailsForm {
        EmployeeId: Serenity.IntegerEditor;
        DepartmentId: Serenity.IntegerEditor;
    }

    export class EmployeeDetailsForm extends Serenity.PrefixedContext {
        static formKey = 'Master.EmployeeDetails';
        private static init: boolean;

        constructor(prefix: string) {
            super(prefix);

            if (!EmployeeDetailsForm.init)  {
                EmployeeDetailsForm.init = true;

                var s = Serenity;
                var w0 = s.IntegerEditor;

                Q.initFormType(EmployeeDetailsForm, [
                    'EmployeeId', w0,
                    'DepartmentId', w0
                ]);
            }
        }
    }
}
